import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { PlayerProvider } from "./context/PlayerContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MiniPlayer from "./components/MiniPlayer";
import Home from "./pages/Home";
import Programmas from "./pages/Programmas";
import Geschiedenis from "./pages/Geschiedenis";
import Luisterlinks from "./pages/Luisterlinks";
import Playlist from "./pages/Playlist";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App relative min-h-screen w-full max-w-full overflow-x-hidden bg-transparent">
      {/* Global background: dot grid + soft glow circles across the whole site */}
      <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden" aria-hidden="true">
        <div className="absolute inset-0 bg-dot-grid opacity-60" />
        <div className="absolute -top-40 -left-32 h-[32rem] w-[32rem] rounded-full bg-white/20 blur-3xl" />
        <div className="absolute top-1/4 right-0 h-[28rem] w-[28rem] rounded-full bg-[#5AA6FF]/30 blur-3xl" />
        <div className="absolute top-1/2 -left-24 h-[26rem] w-[26rem] rounded-full bg-white/15 blur-3xl" />
        <div className="absolute bottom-24 right-10 h-[30rem] w-[30rem] rounded-full bg-[#5AA6FF]/25 blur-3xl" />
        <div className="absolute bottom-0 left-1/3 h-[24rem] w-[24rem] rounded-full bg-white/15 blur-3xl" />
      </div>
      <PlayerProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/programmas" element={<Programmas />} />
              <Route path="/geschiedenis" element={<Geschiedenis />} />
              <Route path="/luisterlinks" element={<Luisterlinks />} />
              <Route path="/playlist" element={<Playlist />} />
            </Routes>
          </main>
          <Footer />
          <MiniPlayer />
        </BrowserRouter>
      </PlayerProvider>
    </div>
  );
}

export default App;
